// extracted by mini-css-extract-plugin
export var category = "category-module--category--mw17C";